import { render, staticRenderFns } from "./AdditionalService.vue?vue&type=template&id=3b369991&"
import script from "./AdditionalService.vue?vue&type=script&lang=js&"
export * from "./AdditionalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports